export const environment = {
  envName: "staging",
  production: false,
  graphqlUrl: "https://ci-ivar.tado.com/graphql",
  hvacUrl: "https://ci-hvactool.tado.com",
  amplify: {
    Auth: {
      Cognito: {
        userPoolId: "eu-west-1_gYujnrYaT",
        userPoolClientId: "533bvq5g6r2tc85g7i7fk8gci",
        loginWith: {
          oauth: {
            domain: "ivar-staging.auth.eu-west-1.amazoncognito.com",
            scopes: ["email", "profile", "openid"],
            redirectSignIn: ["https://ci-ivar.tado.com/"],
            redirectSignOut: ["https://ci-ivar.tado.com/"],
            // 'code' for Authorization code grant,
            // 'token' for Implicit grant
            // Note that REFRESH token will only be generated when the responseType is code
            responseType: "code",
          },
        },
      },
    },
  },
};
